module.exports = __webpack_public_path__ + "static/img/far1.8a3fbbac.png";